
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_o08jm_17hgw_9",
  "group-layout-wrapper": "awsui_group-layout-wrapper_o08jm_17hgw_41",
  "action-slot": "awsui_action-slot_o08jm_17hgw_45",
  "group-layout": "awsui_group-layout_o08jm_17hgw_41",
  "group-layout-horizontal": "awsui_group-layout-horizontal_o08jm_17hgw_55",
  "group-layout-vertical": "awsui_group-layout-vertical_o08jm_17hgw_58",
  "controls": "awsui_controls_o08jm_17hgw_62",
  "controls-horizontal": "awsui_controls-horizontal_o08jm_17hgw_66",
  "controls-vertical": "awsui_controls-vertical_o08jm_17hgw_72",
  "control": "awsui_control_o08jm_17hgw_62",
  "control-middle-horizontal": "awsui_control-middle-horizontal_o08jm_17hgw_81",
  "control-last-horizontal": "awsui_control-last-horizontal_o08jm_17hgw_81",
  "control-middle-vertical": "awsui_control-middle-vertical_o08jm_17hgw_84",
  "control-last-vertical": "awsui_control-last-vertical_o08jm_17hgw_84",
  "sensor": "awsui_sensor_o08jm_17hgw_93",
  "ghost-anchor": "awsui_ghost-anchor_o08jm_17hgw_105",
  "inline-label": "awsui_inline-label_o08jm_17hgw_110",
  "inline-label-wrapper": "awsui_inline-label-wrapper_o08jm_17hgw_135",
  "inline-label-trigger-wrapper": "awsui_inline-label-trigger-wrapper_o08jm_17hgw_140",
  "ghost": "awsui_ghost_o08jm_17hgw_105"
};
  